import { Box, Stack, useTheme } from "@mui/material";
import { useGlobalStore } from "controller";
import { PaymentFailedBanner } from "components/banner/PaymentFailedBanner";
import { OverviewTab04 } from "./OverviewTab04";

export const SubscriptionDetails = () => {
  const theme = useTheme();
  const subscriptionStatus = useGlobalStore(
    (state) => state.subscriptionStatus,
  );

  return (
    <Stack sx={{ height: "calc(100vh - 64px)" }}>
      <Box
        sx={{
          flex: 1,
          display: "flex",
          flexDirection: "column",
          height: "100%",
        }}
      >
        {subscriptionStatus === "past_due" && (
          <PaymentFailedBanner showButton={false} />
        )}

        <Box
          sx={{
            flex: 1,
            p: "8px",
            display: "flex",
            flexDirection: "row",
            backgroundColor: theme.palette.neutral["005"],
          }}
        >
          <OverviewTab04 />
        </Box>
      </Box>
    </Stack>
  );
};
